import { initialAgreementListState } from '../constants/initialAgreementListState';
import { AgreementListActionsEnum } from '../enums/AgreementListActionsEnum';
import { IAgreementListState } from '../interfaces/IAgreementListState';
import { AgreementListAction } from '../types/AgreementListAction';

export function agreementListReducer(state = initialAgreementListState, action: AgreementListAction) {
  switch (action.type) {
    case AgreementListActionsEnum.AGREEMENT_LIST_SET_SEARCH_VALUE: {
      const newState: IAgreementListState = {
        ...state,
        searchValue: action.payload.value,
      };

      return newState;
    }
    case AgreementListActionsEnum.AGREEMENT_LIST_SET_DATA: {
      const { data, page, totalCount, pageCount, rejected } = action.payload;
      const newState: IAgreementListState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
        rejected,
      };

      return newState;
    }
    case AgreementListActionsEnum.AGREEMENT_LIST_SET_FIND_DATA: {
      const { findData } = action.payload;
      const newState: IAgreementListState = {
        ...state,
        findData,
      };

      return newState;
    }
    case AgreementListActionsEnum.AGREEMENT_LIST_SET_ORDER: {
      const { order } = action.payload;
      const newState: IAgreementListState = {
        ...state,
        order,
      };

      return newState;
    }
    default:
      return state;
  }
}
